'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var svg_path = "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M11.34 23.6263C11.7093 23.9965 12.2907 23.9965 12.66 23.6263C14.7367 21.5449 21 14.7951 21 9.10096C21 4.07464 16.9706 0 12 0C7.02944 0 3 4.07464 3 9.10096C3 14.7951 9.26335 21.5449 11.34 23.6263ZM12 12C14.0711 12 15.75 10.3211 15.75 8.25C15.75 6.17893 14.0711 4.5 12 4.5C9.92893 4.5 8.25 6.17893 8.25 8.25C8.25 10.3211 9.92893 12 12 12Z\" fill=\"#26201F\"/>\n</svg>";

exports["default"] = svg_path;
